import { createFileRoute } from '@tanstack/react-router';
import { Button, Stack, Text } from '@mantine/core';
import { useEffect, useState } from 'react';
import { LayoutCard } from '@/components/layouts/LayoutCard';
import { useFeedbackSurvey } from '@/hooks/useFeedbackSurvey';
import { useCookieConsent } from '@/hooks/useCookieConsent';
import { FeedbackModal } from '@/components/common/FeedbackModal';

export const Route = createFileRoute('/feedback')({
  component: FeedbackPage,
});

function FeedbackPage() {
  const { showFeedbackSurvey } = useFeedbackSurvey();
  const { consentStatus } = useCookieConsent();
  const [feedbackModalOpened, setFeedbackModalOpened] = useState(false);

  // Auto-trigger feedback when page loads
  // Use Convex form if cookies denied, PostHog survey if cookies accepted/pending
  useEffect(() => {
    if (consentStatus === 'denied') {
      setFeedbackModalOpened(true);
    } else {
      showFeedbackSurvey('general', 'direct_link');
    }
  }, [showFeedbackSurvey, consentStatus]);

  const handleRetryClick = () => {
    if (consentStatus === 'denied') {
      setFeedbackModalOpened(true);
    } else {
      showFeedbackSurvey('general', 'manual_retry');
    }
  };

  return (
    <>
      <LayoutCard title="Feedback" maxWidth="md">
        <Stack gap="md">
          {consentStatus === 'denied' ? (
            <Text>
              The feedback form should have opened automatically. If you don't see it,
              click the button below.
            </Text>
          ) : (
            <>
              <Text>
                The feedback survey should have opened automatically. If you have
                analytics enabled and don't see it, click the button below.
              </Text>
              <Text size="sm" c="dimmed">
                If you've disabled analytics, a feedback form will be shown instead.
              </Text>
            </>
          )}
          <Button onClick={handleRetryClick}>
            {consentStatus === 'denied' ? 'Open Feedback Form' : 'Open Survey Again'}
          </Button>
        </Stack>
      </LayoutCard>

      {/* Feedback modal for users who rejected cookies */}
      <FeedbackModal
        opened={feedbackModalOpened}
        onClose={() => setFeedbackModalOpened(false)}
      />
    </>
  );
}
